export default __webpack_public_path__ + "static/media/emptyPageImage.899b700a.svg";